import { Component, inject, Input } from '@angular/core';
import { POLARIS_NAME } from '../../../copilot.model';
import { PolarisIconComponent } from '../../polaris-icon/polaris-icon.component';
import { DrawerService, IDrawerRef } from '../../../../../services/drawer.service';
import { DashboardWidget, ASK_POLARIS_SIDE_DRAWER_WIDTH } from '../../../types';
import { AskPolarisSideDrawerComponent } from '../ask-polaris-side-drawer/ask-polaris-side-drawer.component';

@Component({
  selector: 'app-ask-polaris-button',
  imports: [
    PolarisIconComponent
  ],
  templateUrl: './ask-polaris-button.component.html',
  styleUrl: './ask-polaris-button.component.scss'
})
export class AskPolarisButtonComponent {
  @Input({ required: true }) widget!: DashboardWidget;
  @Input() selectedMetrics?: string[];
  private drawerService = inject(DrawerService);
  private askPolarisSideDrawerRef?: IDrawerRef<AskPolarisSideDrawerComponent>;
  public tooltip: string = `Ask ${POLARIS_NAME}`;

  public onButtonClick(): void {
    if (!this.widget) return;
    this.openAskPolarisSideDrawer(this.widget);
  }

  private openAskPolarisSideDrawer(widget: DashboardWidget): void {
    this.askPolarisSideDrawerRef = this.drawerService.open(
      AskPolarisSideDrawerComponent, {
      width: ASK_POLARIS_SIDE_DRAWER_WIDTH,
      data: {
        widget,
        selectedMetrics: this.selectedMetrics,
        close: () => this.askPolarisSideDrawerRef?.close()
      }
    }
    );
  }
}
